module.exports = __webpack_public_path__ + "img/help17.fb63608e.png";